export enum OrgAuthType {
    NONE = 'NONE',
    JOIN = 'JOIN',
    FAILED = 'FAILED'
}